import { useTranslations } from "next-intl";

import { FormToggle } from "@/components/form/FormToggle";
import { Icon } from "@/components/icons/Icon";
import { MENU_ITEM_BUTTON_CLASS, MenuItemContent } from "@/components/sidebar/MenuItemContent";
import { twMerge } from "@/utils/twMerge";

import type { DropdownItemRenderProps } from "@/components/sidebar/Dropdown";

export function LockBlockButton({
  locked,
  onLockedChange,
  ...props
}: DropdownItemRenderProps & {
  locked: boolean;
  onLockedChange: (locked: boolean) => void;
}) {
  const t = useTranslations();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    onLockedChange(!locked);
  };

  return (
    <button
      type="button"
      {...props}
      onClick={handleClick}
      aria-label={t("tiptap.lockBlock")}
      data-testid="line-options-dropdown-lock"
      className={twMerge(
        MENU_ITEM_BUTTON_CLASS,
        "outline-none data-[focus]:bg-sidebar-button-active-bg",
      )}
    >
      <MenuItemContent
        item={{
          title: t("tiptap.lockBlock"),
          icon: <Icon name={locked ? "LockLocked" : "LockUnlocked"} />,
        }}
      />
      <FormToggle checked={locked} className="ml-auto" />
    </button>
  );
}
